import { parse } from 'query-string';
import { handleErrors, HTTP_CODE } from '../../utils/redirector-utils';

export function isNotFound({ data, error, itemId }) {
  
  if (data && !data.product) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND,
      description: `Item ${itemId} not fonud`
    };
  }

  return null;
}

export function isInvalidItemId({ itemId }) {

  if (!/^\d{8,10}$/.test(itemId)) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND,
      description: `Invalid item id ${itemId}`
    };
  }

  return null;
}

export function isInvalidCanonical({ data, disableCanonicalRedirect, path }) {

  let normalizedPath = path;
  let isReservationsPage;
  if ((path || '').startsWith('/p/rental/reservations/')) {
    isReservationsPage = true;
    normalizedPath = path.replace('/reservations', '');
  }
  let { canonicalUrl } = data?.product?.identifiers || {};

  if (!canonicalUrl) {
    return null;
  }

  // Added to fix rental canonicalUrls no starting with a /
  if (canonicalUrl.startsWith('p/rental/')) {
    canonicalUrl = canonicalUrl.replace('p/rental/', '/p/rental/');
  }

  if (!disableCanonicalRedirect && normalizedPath !== canonicalUrl) {

    return {
      shouldRedirect: true,
      httpCode: HTTP_CODE.PERM_REDIRECT,
      redirectPath: isReservationsPage ? canonicalUrl.replace('/p/rental/', '/p/rental/reservations/') : canonicalUrl,
      description: 'redirected for canonical'
    };
  }

  return null;
}
